<template>
    <div class="class-tabs">
        <el-tabs>
            <!-- @tab-click="handleClick"v-model="activeName" -->
            <el-tab-pane v-for="(single,index) in list" :key="index">
                <span slot="label" class="lable-title" @click="handleClick(index)">
                    <span class="lable-text">{{ single.name | ellipsis(6)}}</span>
                </span>
                <div class="article">
                    <div
                        v-for="(item,index2) in single.article"
                        class="text"
                        :key="index2"
                        :class="{'last': index2 == 3}"
                        v-if="index2 < 8"
                    >
                        <single-article  :index="index2+1"  :single="item" :hide="index2 > 0" :create="true"></single-article>
                    </div>
                    <div class="more-btn" v-if="position == 'bottom'">
                        <div class="more-center" @click="more(single)">加载更多</div>
                    </div>
                    <div class="more-wrap" v-else>
                        <div class="more" @click="more(single)">
                            查看更多
                            <i class="el-icon-right"></i>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import SingleArticle from '../common/SingleArticle';
    export default {
        props: {
            list: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            position: {
                type: String,
                default: 'top'
            }
        },
        components: {
            SingleArticle
        },
        methods: {
            handleClick(index) {
                console.log('ccc', index);
            },
            more(item) {
                // 面包屑
                let breadObj = {
                    id: item.id,
                    path: 'article-list?id=' + item.id,
                    name: item.name
                };
                this.$store.commit('setBreadArr', breadObj);
                this.$router.push({
                    name: 'article-list',
                    query: {
                        id: item.id
                    }
                });
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .class-tabs {
        // margin-top: 20px;
        // height: 836px;
        background: #F6F6F6;
        font-family: 'SimSun';
        // font-family: "Noto Serif SC";
    }

    >>>.el-tabs {
        height: 100%;
        overflow: hidden;
    }

    >>>.el-tabs__header {
        margin: 0 0 0 0;
    }

    >>>.el-tabs__content {
        height: 91.5%;
        background: white;
    }

    >>>.el-tabs__nav {
        height: 96px;
        width: 100%;
        background: #f6f6f6;
        flex-x(space-around, center);
    }

    >>>.el-tabs__active-bar {
        height: 0px;
        background-color: white;
    }

    >>>.el-tabs__item.is-active:before {
        content: '';
        width: 0px;
        height: 0px;
        border-top: 12px solid #4093FF;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        position: absolute;
        top: 100%;
        left: 42%;
    }

    >>>.el-tabs__item.is-active {
        color: white;
        background: #4093FF;
        height: 56px;
        width: 17%;

        .lable-text {
            border: 0px solid #999;
        }
    }

    >>>.el-tabs__item.is-active:after {
        content: '';
        width: 1px;
        height: 56px;
        position: absolute;
        top: 0;
        left: 98%;
        background: #4093FF;
        border-left: 2px solid #4093FF;
    }

    >>>.el-tabs__item {
        height: 56px;
        width: 17%;
        text-align: center;
        padding: 0;
        color: #333;
        background-color: white;
    }

    #tab-0 .lable-text {
        border: 0px solid #999;
    }

    .lable-title {
        flex-x(center);
        width: 100%;
        text-align: center;
        height: 56px;
        font-size: 20px;
        font-weight: 600;
    }

    .lable-text {
        flex-x(center);
        width: 100%;
        text-align: center;
        height: 20px;
        font-size: 20px;
        // font-weight: 600;
        border-left: 1px solid #999;
        margin-left: -2px;
    }

    .article {
        height: 100%;
        min-height: 764px;
    }

    .text {
        &.last {
            border-bottom: 0px solid white;
        }
    }

    .cell-text {
        text-align: left;
        max-width: 85%;
        ellipsis();

        p {
            width: 100%;
            ellipsis();
        }
    }

    .cell-text:hover {
        color: #1876F0;
        cursor: pointer;

        p {
            color: #1876F0;
        }
    }

    .text-spec {
        flex-x(flex-start);

        .spec-mulit {
            multi(3);
        }

        .text-img {
            margin-left: 32px;

            img {
                width: 156px;
                height: 104px;
                border-radius: 4px;
            }
        }
    }

    .text-icon {
        margin-top: 8px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
        height: 17px;
        flex-x();

        i {
            font-size: 12px;
            margin-right: 5px;
        }

        svg {
            icon-c(12px, #197DFF);
            fill: #197DFF;
            margin-right: 5px;
        }

        span {
            margin-right: 16px;
            flex-x();
        }
    }

    .more-wrap {
        width: 100%;
        height: 45px;
        background: white;
    }

    .more {
        more();
        position: absolute;
        bottom: 15px;
        left: 25px;
        color: #197DFF;
        padding-top: 10px;
    }

    .more-btn {
        width: 100%;
        height: 100px;
        background: white;
        flex-x(center);

        .more-center {
            width: 832px;
            height: 54px;
            background: rgba(236, 245, 255, 1);
            border-radius: 8px;
            border: 1px solid rgba(163, 208, 253, 1);
            flex-center();
            font-size: 14px;
            font-weight: 400;
            color: rgba(25, 125, 255, 1);
            line-height: 22px;
        }

        .more-center:hover {
            cursor: pointer;
        }
    }
</style>
